import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Injectable, NgModule, enableProdMode } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthHttpInterceptor, AuthModule as Auth0Module } from "@auth0/auth0-angular";
import { MSAL_INSTANCE, MsalModule, MsalService } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { msalConfig } from "./auth-config";
import { AuthModule } from "./auth/auth.module";
import { auth0Config } from "./auth0-config";
import { CoreModule } from "./core/core.module";
import { OnboardingModule } from "./onboarding/onboarding.module";
import { PlatformModule } from "./platform/platform.module";
import { ProviderModule } from "./provider/provider.module";
import { MessagingModule } from "./shared/messaging/messaging.module";
import { ToolboxModule } from "./toolbox/toolbox.module";
import { DevControlsModule } from "./zdevcontrols/zdevcontrols.module";

export const MSALInstanceFactory = (): IPublicClientApplication => new PublicClientApplication(msalConfig);

const developmentModules = [];
if (environment.production) {
  enableProdMode();
} else {
  developmentModules.push(ToolboxModule);
  // developmentModules.push(DevControlsModule); // TODO: Remove this module from production build.
}

@Injectable({ providedIn: "root" })
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    DevControlsModule,
    ...developmentModules,
    BrowserModule,
    CoreModule,
    PlatformModule,
    AuthModule,
    FormsModule,
    BrowserAnimationsModule,
    OnboardingModule,
    MessagingModule,
    ProviderModule,
    MsalModule,
    // Auth0Module.forRoot(auth0Config),
  ],
  providers: [
    MsalService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthHttpInterceptor,
    //   multi: true,
    // },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
